import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { InformationCard } from 'components/Smp/InformationCard/InformationCard'
import React, { FC, Fragment } from 'react'
import { scopedTranslation } from 'src/helpers'

import { RegisterButton } from '../RegisterButton/RegisterButton'

const { t } = scopedTranslation('component.smp.landing_page.theme_section')

export const ThemeSection: FC = () => (
  <Fragment>
    <Box textAlign='center'>
      <Typography variant='h2'>{ t('headline') }</Typography>
    </Box>
    <Box textAlign='center' my={ 2 } mb={ 20 }>
      <Typography>{ t('description') }</Typography>
    </Box>
    <Box mt={ 6 }>
      <InformationCard isPreview={ true } />
    </Box>
    <Box mt={ 9 } mb={ 12 }>
      <RegisterButton
        buttonKey='call-to-action-low'
        centered={ true }
      />
    </Box>
  </Fragment>
)
